import { render, staticRenderFns } from "./BaseIconButton.vue?vue&type=template&id=351fffec&scoped=true&lang=html&"
import script from "./BaseIconButton.vue?vue&type=script&lang=js&"
export * from "./BaseIconButton.vue?vue&type=script&lang=js&"
import style0 from "./BaseIconButton.vue?vue&type=style&index=0&id=351fffec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351fffec",
  null
  
)

export default component.exports